import { UserRoleDto } from '../services/usersapi/usersapi.services';

export class AssignRolesByUserIdRequest {
  userId: string;
  requestBody: UserRoleDto[];
}
